import LoadingSpinner from '../../Helpers/LoadingSpinner';
import useVerifySessionAuth0 from '../../Hooks/useVerifySessionAuth0';
import { useAuth0 } from '@auth0/auth0-react';
import { useStore } from '../../Store/storeProvider';
import getSegmentAndGaFromCookies from '../../Helpers/getSegmendAndGaFromCookies';
import { GetOriginId } from '../../Helpers/Origin';
import * as storage from '../../Helpers/Auth0StorageManager';

const Auth0GoogleLogin = () => {
    const { loginWithRedirect } = useAuth0();
    const { Config } = useStore();
    const { segment, ga } = getSegmentAndGaFromCookies();

    const googleLoginHandler = async () => {
        const { SitioId, Modo, UserEmail, URLCallback } = Config;

        storage.setSitioId(SitioId);
        storage.setModo(Modo);
        
        if (UserEmail) {
            const origenId = GetOriginId(SitioId, URLCallback);
            loginWithRedirect({
                connection: 'google-oauth2',
                login_hint: UserEmail,
                modo: `${Modo}`,
                origen: origenId,
                "ext-origen": `${origenId}`,
                redirectUri: `${window.location.origin}/auth0-callback/?callback=${window.btoa(URLCallback)}`,
                segment: segment,
                ga: ga,
                event_name: "googleOneTap"
            });
        } else {
            window.location = `${window.location.origin}/auth0-login/${Modo}/${SitioId}/?callback=${window.btoa(URLCallback)}`;
        }
    };

    const [isLoadingProcess] = useVerifySessionAuth0(googleLoginHandler);

    return (
        <div className="callback-view containerSpinner">
            <LoadingSpinner isLoading={isLoadingProcess}></LoadingSpinner>
        </div>
    );
};
export default Auth0GoogleLogin;
